export const autocomplete = {
    itemId: 'itemId',
    itemText: 'itemText',
} as const;

export type TAutoComplete = (typeof autocomplete)[keyof typeof autocomplete];

export interface IAutoComplete {
    [autocomplete.itemId]: string | number;
    [autocomplete.itemText]: string;
}

export class AutoComplete implements IAutoComplete {
    [autocomplete.itemId]!: string | number;
    [autocomplete.itemText]!: string;

    private constructor(id: string | number, text: string) {
        this[autocomplete.itemId] = id;
        this[autocomplete.itemText] = text;
    }

    static create(id: string | number | null, text: string | null): IAutoComplete | null {
        if(id === null || text === null) return null;
        
        return new AutoComplete(id, text);
    }
}

// Waarde en tekst van een lijst-item dat een IAutoComplete-object of een losse string is.
// Voor controls die op de primitieve waarde vergelijken (button-toggle, radio): itemId als waarde.
export function autoComplete_text(item: IAutoComplete | string): string {
    return typeof item === 'string' ? item : item?.[autocomplete.itemText];
}

export function autoComplete_value(item: IAutoComplete | string): string | number {
    return typeof item === 'string' ? item : item?.[autocomplete.itemId];
}
